import {Either, getValidation, mapLeft} from 'fp-ts/lib/Either';
import {getSemigroup, NonEmptyArray} from 'fp-ts/lib/NonEmptyArray';
import {pipe} from 'fp-ts/lib/pipeable';

export const liftT = <TReturn>() =>
  function<E, A>(check: (a: A) => Either<E, TReturn>): (a: A) => Either<NonEmptyArray<E>, TReturn> {
    return a =>
      pipe(
        check(a),
        mapLeft(a => [a])
      );
  };

export function lift<E, A>(check: (a: A) => Either<E, A>): (a: A) => Either<NonEmptyArray<E>, A> {
  return a =>
    pipe(
      check(a),
      mapLeft(a => [a])
    );
}

export const applicativeValidation = getValidation(getSemigroup<string>());
